import { useEffect, useState } from "react";
import { getExtruderSettings } from "../api/extruder";
import {
  DEFAULT_THRESHOLDS,
  thresholdsFrom,
  type ScrewThresholds,
} from "./screwSpeed";

/**
 * The plant's extruder bands from `/settings/extruders`.
 *
 * `settings_extruders` is a single row shared by both lamination lines, so
 * every caller wants the same values and gets them the same way. Until the
 * request answers — or if it fails — the defaults stand rather than blocking
 * the page on a settings lookup.
 */
export function useExtruderThresholds(): ScrewThresholds {
  const [thresholds, setThresholds] =
    useState<ScrewThresholds>(DEFAULT_THRESHOLDS);

  useEffect(() => {
    const controller = new AbortController();
    getExtruderSettings(controller.signal)
      .then((j) => setThresholds(thresholdsFrom(j)))
      .catch(() => {
        /* keep defaults */
      });
    return () => controller.abort();
  }, []);

  return thresholds;
}
